/* eslint-disable react-refresh/only-export-components -- context module exports hooks + provider */
import { createContext, useContext, useLayoutEffect, useState } from 'react'
import type React from 'react'
import { tcmApiClient } from '../../../services/tcmApiClient'

const SESSION_ID_HEADER = 'X-Session-ID'

type EncounterSessionContextValue = {
  sessionId: string
  resetSession: () => void
}

const EncounterSessionContext =
  createContext<EncounterSessionContextValue | null>(null)

export function useEncounterSession(): EncounterSessionContextValue {
  const value = useContext(EncounterSessionContext)
  if (!value) {
    throw new Error(
      'useEncounterSession must be used within EncounterSessionProvider',
    )
  }
  return value
}

export function EncounterSessionProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [sessionId, setSessionId] = useState(() => crypto.randomUUID())

  useLayoutEffect(() => {
    tcmApiClient.defaults.headers.common[SESSION_ID_HEADER] = sessionId
    return () => {
      delete tcmApiClient.defaults.headers.common[SESSION_ID_HEADER]
    }
  }, [sessionId])

  const resetSession = () => setSessionId(crypto.randomUUID())

  return (
    <EncounterSessionContext.Provider value={{ sessionId, resetSession }}>
      {children}
    </EncounterSessionContext.Provider>
  )
}
